import type React from 'react';

import { Grid } from '@mui/material';
import { OrdIconStandard, ServiceItem } from '@ragu-components/ord-components';
import { PersonalAccessToken } from '@ragu-components/ord-resources';
import { useCreatePath, useTranslate } from 'react-admin';

import { ChangePassword } from 'src/views/personal/changePassword';
import { TOTP } from 'src/views/personal/totp';
import { UserSettings } from 'src/views/personal/userSettings';
import { VoicemailSettings } from 'src/views/personal/voicemailSettings';
import { PersonalAccessTokensCreateInDialogButton } from 'src/views/Resources/personal';

export const Settings = (): React.ReactElement => {
  const translate = useTranslate();
  const createPath = useCreatePath();
  return (
    <Grid container spacing={2}>
      <Grid>
        <ServiceItem
          buttonLabel={translate('ord.settings.userSettings.settingButtonLabel')}
          description=''
          icon={<OrdIconStandard name='userPolicy' />}
          name={translate(`ord.settings.userSettings.title`)}
          to={<UserSettings />}
        />
      </Grid>
      <Grid>
        <ServiceItem
          buttonLabel={translate('ord.settings.changePassword.settingButtonLabel')}
          description=''
          icon={<OrdIconStandard name='password' />}
          name={translate(`ord.settings.changePassword.title`)}
          to={<ChangePassword />}
        />
      </Grid>
      <Grid>
        <ServiceItem
          buttonLabel={translate('ord.settings.totp.settingButtonLabel')}
          description=''
          icon={<OrdIconStandard name='pin' />}
          name={translate(`ord.settings.totp.title`)}
          to={<TOTP />}
        />
      </Grid>
      <Grid>
        <ServiceItem
          buttonLabel={translate('resources.voicemails.settingButtonLabel')}
          description=''
          icon={<OrdIconStandard name='voicemail' />}
          name={translate('resources.voicemails.name')}
          to={<VoicemailSettings />}
        />
      </Grid>
      <Grid>
        <ServiceItem
          buttonLabel={translate('ra.action.show')}
          description={translate('resources.me/personal_access_tokens.description')}
          icon={<OrdIconStandard name='token' />}
          name={translate('resources.me/personal_access_tokens.name')}
          shortcutLink={
            <PersonalAccessTokensCreateInDialogButton
              ButtonProps={{
                sx: {
                  minWidth: 0,
                  width: 'fit-content',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  textTransform: 'none',
                  paddingX: 0,
                  '& .MuiButton-startIcon': {
                    display: 'none',
                  },
                },
              }}
              label='resources.me/personal_access_tokens.operations.create'
            />
          }
          to={createPath({ resource: `me/${PersonalAccessToken}`, type: 'list' })}
        />
      </Grid>
    </Grid>
  );
};
